import React from 'react';
const IconRatingWink = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.5 11.25C16.4665 11.25 17.25 10.4665 17.25 9.5C17.25 8.5335 16.4665 7.75 15.5 7.75C14.5335 7.75 13.75 8.5335 13.75 9.5C13.75 10.4665 14.5335 11.25 15.5 11.25Z" fill="#2D2E2E"/>
<path d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="#2D2E2E"/>
<path d="M11.9998 16C10.5698 16 9.27982 15.25 8.54982 13.99L6.81982 14.99C7.89982 16.85 9.87982 18 11.9998 18C14.1198 18 16.0998 16.85 17.1798 14.99L15.4498 13.99C14.7198 15.25 13.4298 16 11.9998 16Z" fill="#2D2E2E"/>
<path d="M10.25 8.5H6.75V10.5H10.25V8.5Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconRatingWink;